import { PageHeader } from '../../app/PageHeader'
import copy from '../../demo/fixtures/copy.json'
import { RenewalPlan } from './RenewalPlan'

export function RenewalPage() {
  const page = copy.pages.renewal

  return (
    <>
      <PageHeader title={page.title} subtitle={page.subtitle} />
      <RenewalPlan />
    </>
  )
}
